import client from './client';

// F-07 微信授权登录 API

export interface WechatAuthUrl {
  enabled: boolean;
  url: string | null;
}

export async function fetchWechatAuthUrl(redirect?: string): Promise<WechatAuthUrl> {
  const { data } = await client.get('/auth/wechat/url', { params: { redirect: redirect || undefined } });
  return data;
}

/** 已登录用户绑定微信授权链接（个人中心，回调直接绑定当前账号免短信） */
export async function fetchWechatBindUrl(): Promise<WechatAuthUrl> {
  const { data } = await client.get('/auth/wechat/bind-url');
  return data;
}

/** 登录票券兑换 Token（已绑定微信用户） */
export async function exchangeWechatLogin(loginTicket: string): Promise<{ user: any; token: string }> {
  const { data } = await client.post('/auth/wechat/exchange', { loginTicket });
  return data;
}

/** 绑定手机号 + 短信验证码（未绑定微信用户）→ 直接登录 */
export async function bindWechatPhone(body: {
  bindTicket: string;
  phoneNumber: string;
  smsCode: string;
}): Promise<{ user: any; token: string }> {
  const { data } = await client.post('/auth/wechat/bind', body);
  return data;
}

/** 解绑微信（个人中心） */
export async function unbindWechat(): Promise<void> {
  await client.delete('/auth/wechat/unbind');
}